import {createAction, props} from "@ngrx/store";
import {Company} from "../../modules/models/company.type";

export const setCurrentCompany = createAction(
  '[Company] Set CurentCompany',
  props<{ company: Company }>()
);